import { render, staticRenderFns } from "./testPersonInfo.vue?vue&type=template&id=499fa317&scoped=true&"
import script from "./testPersonInfo.vue?vue&type=script&lang=ts&"
export * from "./testPersonInfo.vue?vue&type=script&lang=ts&"
import style0 from "./testPersonInfo.vue?vue&type=style&index=0&id=499fa317&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499fa317",
  null
  
)

export default component.exports